import React, {useCallback, useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Helmet} from 'react-helmet';
import {logPageLoadEvents} from '@ibibo/analytics';

import {fetchThankYouData, thankYouDataSelector, checkinCheckoutSelector, guestSelector, statusSelector, IDSelector, contactInfoSelector, priceInfoSelector, fareBreakupSelector} from '@ibibo/hotels-thankyou-reducer';

import ThankYouBody from '../../../stories/components/hotels/ThankYouPage/ThankYouBody/ThankYouBody';

const ThankYou = () => {
  const dispatch = useDispatch();

  const thankyouData = useSelector(thankYouDataSelector);
  const checkinCheckoutDetail = useSelector(checkinCheckoutSelector);
  const guestDetails = useSelector(guestSelector);
  const statusInfo = useSelector(statusSelector);
  const id = useSelector(IDSelector);
  const contactInfo = useSelector(contactInfoSelector);
  const priceInfo = useSelector(priceInfoSelector);
  const fareBreakup = useSelector(fareBreakupSelector);

  const {hotel_details, room_details, cancellation_policies = [], important_info = {}, actions = [], my_bookings_url='/mytrips/'} = thankyouData;
  const {exclusions = []} = important_info;

  const successCallback = (response) => {
    if (response.poll) {
      setTimeout(() => {
        callThankYouApi();
      }, response.poll_timeout || 2000);
    }
  }

  const callThankYouApi = useCallback((retry = true) => {
    return dispatch(fetchThankYouData({
      id,
      successCallback: successCallback,
      errCallback: () => {
        if (retry) {
          setTimeout(() => {
            callThankYouApi(false);
          }, 3000);
        }
      }
    }));
  }, [dispatch]);

  useEffect(() => {
    if (window) window.scrollTo(0, 0);
    callThankYouApi();
  }, []);

  useEffect(() => {
    if(thankyouData && thankyouData.hotel_details.hotel_country_name){
      let searchType = 'domestic';
      if(thankyouData.hotel_details.hotel_country_name !== "india"){
        searchType = 'intl';
      }
      logPageLoadEvents(`funnel:${searchType} hotels:thankyou`, {});
    }
  }, [thankyouData]);

  const navigateToMyTrips = (toDetails) => {
    if (toDetails) {
      window.open(my_bookings_url, '_self');
    } else {
      window.open('/mytrips/', '_self');
    }
  }

  return (
    <>
      <Helmet
        title={'myPartner - Booking Confirmation ' + hotel_details.hotel_name}
        meta={[{name: 'robots', content: 'noindex, nofollow'}]}
      />
      <ThankYouBody
        statusInfo={statusInfo}
        hotelDetails={hotel_details}
        roomDetails={room_details}
        checkinCheckoutDetail={checkinCheckoutDetail}
        guestDetails={guestDetails}
        cancellationPolicies={cancellation_policies}
        exclusions={exclusions}
        contactInfo={contactInfo}
        priceInfo={priceInfo}
        fareBreakup={fareBreakup}
        navigateToMyTrips={navigateToMyTrips}
        actions={actions}
      />
    </>
  );
};

export default ThankYou;
